import type React from 'react'
import { useState } from 'react'
import PageWrapper from '../../../../../components/Pagewrapper'
import VeliClientsTab from './components/VeliClientsTab'
import WealthManagersTab from './components/WealthManagersTab'

type Tab = 'wealth-managers' | 'clients'

// The admin "Veli Migration" area. Tab 1 is the wealth-manager table — a row drills into that WM's
// detail sub-page (identity, lifecycle actions, their book). Tab 2 is the flat roster of every imported
// Veli client across all books. The old all-books "activation funnel" is gone: each WM's funnel now lives
// on its own sub-page.
const VeliMigrationScreen: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('wealth-managers')

  return (
    <PageWrapper
      title="Veli Migration"
      tabs={[
        {
          title: 'Wealth Managers',
          active: activeTab === 'wealth-managers',
          onPress: () => setActiveTab('wealth-managers'),
        },
        {
          title: 'Clients',
          active: activeTab === 'clients',
          onPress: () => setActiveTab('clients'),
        },
      ]}
    >
      {activeTab === 'wealth-managers' ? <WealthManagersTab /> : <VeliClientsTab />}
    </PageWrapper>
  )
}

export default VeliMigrationScreen
